import Nav from "./nav/Nav";
import ImgAlien from "./alienImg/ImgAlien";
import { Route, Routes, Link } from "react-router-dom";
import RoadMap from './RoadMap/RoadMap';
import { Wallet } from "./Solana/SolanaConnectBtn";
import Twitter_Img from "./twitter_logo.png";
import Discord_Img from "./discord-logo.png";
import Raffles from "./Raffles";
import Auctions from "./Auctions"
import Staking from "./Staking"
import MyateryBoxes from "./MyateryBoxes"
import CoinFlip from "./CoinFlip";


function App() {
  return (
    <div className="App">
      <div id="layout" class="stars">
        <div id="ShootingStarParams"></div>
      </div>
      <section className="header_sec">
        <Link to="/"><h1>Ancient Aliens</h1></Link>
        <div className="social"><Wallet className="connectbtn"/></div>
      </section>

      <section id="main-sec">
        <div id="container">
          <Nav/>
          <Routes>
            <Route path='/' exact element={<ImgAlien/>}/>
            <Route path='/Raffles' exact element={<Raffles/>}/>
            <Route path='/Auctions' exact element={<Auctions/>}/>
            <Route path='/Staking' exact element={<Staking/>}/>
            <Route path='/MyateryBoxes' exact element={<MyateryBoxes/>}/>
            <Route path='/RoadMap' exact element={<RoadMap/>}/>
            <Route path="/SpinCoin" exact element={<CoinFlip/>}/>
          </Routes>
        </div>
      </section>
      <div className='scialIcons'><a href="/"><img src={Twitter_Img} alt='' className="twr"/></a> <a href="/"><img src={Discord_Img} alt='' className="discrd"/></a></div>
    </div>
  );
}

export default App;
